import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { Trans } from 'react-i18next';
const ForgetPassword = () => {
  return (
    <AuthCardLayout>
      <h4 className="mb-0">
        <Trans ns="auth">Forgot your password?</Trans>
      </h4>
      <p className="mb-0">
        <Trans ns="auth">
          Enter your email and we'll send you a reset link.
        </Trans>
      </p>
      <ForgetPasswordForm layout="card" />
    </AuthCardLayout>
  );
};

export default ForgetPassword;
